export default __webpack_public_path__ + "static/media/main.bb619a82.jpg";